import React from "react";
import { BoxTitle } from "../../../styles/texts";
import { GrayButton } from "../../../styles/buttons";

interface SuccessScreenProps {
  onReturnToProfile: () => void; // Callback para manejar la acción de "Volver a tu perfil"
}

const SuccessScreen: React.FC<SuccessScreenProps> = ({ onReturnToProfile }) => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-white">
      {/* Título */}
      <BoxTitle>✨ Tu carnet se ha subido exitosamente ✨</BoxTitle>

      {/* Botón para volver */}
      <div className="mt-8">
        <GrayButton
          label="Volver a tu perfil"
          onClick={onReturnToProfile}
          w="200px"
          h="50px"
        />
      </div>
    </div>
  );
};

export default SuccessScreen;
